import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { CountriesService } from '@boma/supplier-portal/shared/services';
import { DomSanitizer } from '@angular/platform-browser';
import { IMapMarker } from '@boma/client-shared';

// THIS MODULE WILL REQUIRE A BIT OF REWRITING ITS NOT REALLY BEEN THOUGHT OUT WELL
/*
  - Allow to draw custom areas
  = Allow to set a province as an area
  - Allow to edit area
  - Allow to overlay areas so we can see where is what and how it interacts with everything else


*/

declare const google: any;

@Component({
  selector: 'boma-portal-map',
  templateUrl: './portal-map.component.html',
  styleUrls: ['./portal-map.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PortalMapComponent implements OnInit {
  @Input() location = null;
  @Input() country = null;
  @Input() openingLocation = null;
  @Input() showSave = false;
  @Output() setPolygon = new EventEmitter();
  @Output() saveMap = new EventEmitter();
  @Input() markers: IMapMarker[] = [];
  markerPlain = {
    url: 'assets/layout/images/interface/maps/pin-plain.svg',
    scaledSize: { height: 60, width: 60 },
  };
  markerMove = {
    url: 'assets/layout/images/interface/maps/pin-move.svg',
    scaledSize: { height: 60, width: 60 },
  };

  lat = 14.604847;
  lng = 16.422421;
  pointList: [number, number][] = [];
  selectedArea = 0;
  selectedShape: any;
  drawingManager: any;
  zoomLevel = 5;
  theMap: any;

  isDrawing = false;
  editedMap = false;

  countryAreas: any = [];
  selectedCountryArea: any = [];

  userSelectedCoordinates = {
    long: null,
    lat: null,
  };

  selectedDrawing: any;

  existingDrawArea: any;

  help = false;
  helpSlides = [
    // {
    //   video: this.sanitizer.bypassSecurityTrustHtml(
    //     "<iframe src='https://player.vimeo.com/video/715240941?h=e6a6214593' allow='autoplay; fullscreen'" +
    //       "allowfullscreen frameborder = '0' height = 'auto' style = 'width: 100%;" +
    //       "height: auto;' width='640'></iframe>"
    //   ),
    //   title: 'Flexible Pricing',
    //   text:
    //     'Boma allows you to manage <strong>product</strong> pricing by: <ul class="p-text-left"><li>Location (All customers within the geofence)</li><li>Customer (Just the specified customers regardless of location)</li><li>Or a combination of customers and locations (Specified customers within the geofence)</li></ul> ',
    // },
    {
      image: '/assets/layout/images/favi/apple-icon-144x144.png',
      title: 'Geo Fenced to Country',
      text:
        'All boundaries should be contained within the country, and cannot cross the countries borders.',
    },
    {
      image: '/assets/layout/images/favi/apple-icon-144x144.png',
      title: 'Full Screen',
      text:
        'Click the icon in the top right hand corner\nof the map to enable full screen for easier boundary setting.',
    },
    {
      image: '/assets/layout/images/favi/apple-icon-144x144.png',
      title: 'Drawing',
      text:
        'Click the hand icon at the top of the map to\nstop drawing or just edit your existing area..',
    },
    {
      image: '/assets/layout/images/favi/apple-icon-144x144.png',
      title: 'Right Click to Delete Points',
      text: 'Right click primary points on the map to\n delete them.',
    },
    {
      image: '/assets/layout/images/favi/apple-icon-144x144.png',
      title: 'Move Map',
      text: 'Hold right click down to drag around the map.',
    },
  ];

  constructor(
    private countrySvc: CountriesService,
    public sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    if (!this.location && !this.openingLocation) {
      this.setCurrentPosition();
    }

    if (this.country === 'Zambia') {
      this.countrySvc.getJSON().subscribe((areas) => {
        this.countryAreas = areas.data;
      });
    }
  }

  public setCurrentPosition() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.lat = position.coords.latitude;
        this.lng = position.coords.longitude;
      });
      this.zoomLevel = 18;
    }
  }

  public findCoordinates() {
    this.zoomLevel = 10;
    this.lat = this.userSelectedCoordinates.lat;
    this.lng = this.userSelectedCoordinates.long;
    console.log(this.lat, this.lng);
    const bonds = new google.maps.LatLngBounds();
    bonds.extend(new google.maps.LatLng(this.lat, this.lng));
    this.theMap.fitBounds(bonds);
  }

  onMapReady(map) {
    //this.initDrawingManager(map); // call this only when we want to edit
    this.theMap = map;

    console.log(this.theMap);

    if (this.location) {
      if (this.openingLocation) {
        this.lat = this.openingLocation[1];
        this.lng = this.openingLocation[0];
        this.zoomLevel = 4;
      } else {
        // default to locations first point
        this.lat = this.location[0][1];
        this.lng = this.location[0][0];
      }
      this.drawArea(this.location);
    }
  }

  updatePointList(path) {
    console.log(path);
    this.pointList = [];
    const len = path.getLength();
    for (let i = 0; i < len; i++) {
      const point = path.getAt(i).toJSON();
      this.pointList.push([point.lng, point.lat]);
    }

    this.pointList.push(this.pointList[0]); // to close the path

    console.log(path);
    this.selectedArea = google.maps.geometry.spherical.computeArea(path);
    this.setPolygon.emit(this.pointList);
  }

  // CLEAR THE SHAPES FROM THE MAP
  clearSelection() {
    if (this.setPolygon)
      if (this.selectedShape) {
        this.selectedShape.setEditable(false);
        this.selectedShape = null;
        this.pointList = [];
      }
  }

  //CREATE A SET MAP POLYGON
  setArea(area) {
    console.log(area);
    const googleArray = [];
    area.map(
      (x) => googleArray.push({ lat: x[1], lng: x[0] }) // google seems to have these swapped
    );
    const newArea = new google.maps.Polygon({
      paths: googleArray,
      strokeColor: '#FF00FF',
      strokeOpacity: 0.8,
      strokeWeight: 3,
      fillColor: '#FF00FF',
      fillOpacity: 0.35,
    });
    newArea.setMap(this.theMap);
    googleArray.push(googleArray[0]); // to close the path
    console.log(googleArray[0]);
    this.selectedArea = google.maps.geometry.spherical.computeArea(googleArray);
    this.setPolygon.emit(area);
  }

  setSelection(shape) {
    this.clearSelection();
    this.selectedShape = shape;
    shape.setEditable(true);
  }

  initDrawingManager(map: any, edit: boolean = false) {
    if (this.isDrawing) return;
    this.isDrawing = true;
    const self = this;
    const options = {
      drawingControl: true,
      drawingControlOptions: {
        drawingModes: ['polygon'],
      },
      polygonOptions: {
        draggable: false,
        editable: true,
        strokeColor: '#00ff00',
        strokeOpacity: 1.0,
        strokeWeight: 2,
        fillColor: '#00ff00',
        fillOpacity: 0.33,
      },
      drawingMode: google.maps.drawing.OverlayType.POLYGON,
    };
    this.drawingManager = new google.maps.drawing.DrawingManager(options);
    this.drawingManager.setMap(map);
    google.maps.event.addListener(
      this.drawingManager,
      'overlaycomplete',
      (event) => {
        if (event.type === google.maps.drawing.OverlayType.POLYGON) {
          const paths = event.overlay.getPaths();
          for (let p = 0; p < paths.getLength(); p++) {
            google.maps.event.addListener(paths.getAt(p), 'set_at', () => {
              if (!event.overlay.drag) {
                self.updatePointList(event.overlay.getPath());
              }
            });
            google.maps.event.addListener(paths.getAt(p), 'insert_at', () => {
              self.updatePointList(event.overlay.getPath());
            });
            google.maps.event.addListener(paths.getAt(p), 'remove_at', () => {
              self.updatePointList(event.overlay.getPath());
            });
          }
          self.updatePointList(event.overlay.getPath());
        }
        if (event.type !== google.maps.drawing.OverlayType.MARKER) {
          // Switch back to non-drawing mode after drawing a shape.
          self.drawingManager.setDrawingMode(null);
          // To hide:
          self.drawingManager.setOptions({
            drawingControl: false,
          });
          this.isDrawing = false;
          this.editedMap = true;
        }
      }
    );

    if (this.location && edit) {
      this.editShape(this.location);
    }
  }

  //User has initiated the edit of the map we will draw a new yellow section that will be saved.
  editShape(location) {
    if (!location) return;
    const currentDefinition = [];
    location.map((x) => currentDefinition.push({ lat: x[1], lng: x[0] }));
    this.existingDrawArea = new google.maps.Polygon({
      path: currentDefinition,
      editable: true,
      draggable: false,
      strokeColor: '#FFFF00',
      strokeOpacity: 1.0,
      strokeWeight: 2,
      fillColor: '#FFFF00',
      fillOpacity: 0.33,
      delete: true,
    });
    this.existingDrawArea.setMap(this.theMap);
    const paths = this.existingDrawArea.getPaths();

    //Ability to delete points by right clicking
    google.maps.event.addListener(this.existingDrawArea, 'contextmenu', (e) => {
      const path = this.existingDrawArea.getPath();
      const vertex = e.vertex;

      if (!path || vertex === undefined) {
        return;
      }
      path.removeAt(vertex);
    });

    this.updatePointList(this.existingDrawArea.getPath());

    for (let p = 0; p < paths.getLength(); p++) {
      google.maps.event.addListener(paths.getAt(p), 'set_at', () => {
        this.updatePointList(this.existingDrawArea.getPath());
      });
      google.maps.event.addListener(paths.getAt(p), 'insert_at', () => {
        this.updatePointList(this.existingDrawArea.getPath());
      });
      google.maps.event.addListener(paths.getAt(p), 'remove_at', () => {
        this.updatePointList(this.existingDrawArea.getPath());
      });
    }
  }

  // We use this to draw the current map area that is defined.
  // Its for performance showing 1000's of longitude and latitude points nails performance.
  drawArea(area) {
    if (area === null) {
      area = this.selectedCountryArea.points;
    }
    this.editedMap = true;
    const googleArray = [];
    area.map(
      (x) => googleArray.push({ lat: x[1], lng: x[0] }) // google seems to have these swapped
    );

    const newArea = new google.maps.Polygon({
      paths: googleArray,
      strokeColor: '#FF0000',
      strokeOpacity: 0.8,
      strokeWeight: 3,
      fillColor: '#FF0000',
      fillOpacity: 0.35,
    });

    newArea.setMap(this.theMap);

    newArea.addListener('click', () => {
      // if (
      //   confirm(
      //     'Are you sure you want to edit, complete country maps can take time to load.'
      //   ) !== true
      // )
      //   return;
      this.editShape(this.selectedCountryArea.points);
    });
  }

  saveTheMap() {
    this.saveMap.emit();
  }
}
